import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import ReadonlyLinkedShowsPanelSegment from "document/linkshow/ReadonlyLinkedShowsPanelSegment";
import moment from "moment";
import { InvoiceV2InfoSection } from "InvoiceV2/components/DocumentDetails/InvoiceV2InfoSection";
import PaymentPanelSegment from "InvoiceV2/panelsegment/PaymentsPanel";
import React from "react";
import ReadonlyProductsPanelSegment from "../../Products/ReadonlyProductsPanelSegment";
import TwoColumnLayout from "../../layout/TwoColumnLayout";
import InvoiceActivityPanel from "../components/activity/InvoiceActivityPanel";
import InvoiceV2OptionsPanel from "../components/optionspanel/InvoiceV2OptionsPanel";
import RecipientsPanel from "../panelsegment/RecipientsPanel";
import NotesPanel from "note/list/app";
import { isPanelVisible } from "utilities/panelUtils";
import { InvoiceReminderApp } from "DocumentReminder/AppForInvoices";

interface Props {
  viewModel: server.viewmodel.InvoiceV2DetailFrontModel;
}

const OutstandingPanel = ({ viewModel }: Props) => {
  const sendMoment = moment.utc(viewModel.details.sendDate);
  const dueMoment = sendMoment.add(viewModel.details.dueInDays, "days");
  const localMoment = moment.utc(site.localNow);
  const overDue = localMoment >= dueMoment;

  return (
    <TwoColumnLayout>
      <TwoColumnLayout.LeftColumn>
        <SectionPanel.Section>
          <InvoiceV2InfoSection
            invoice={viewModel.details}
            stepOptions={{
              draft: { disabled: true },
              review: { disabled: true },
              pending: { disabled: false },
              completed: { disabled: true },
            }}
            overDue={overDue}
            activeStep="pending"
            brands={viewModel.brands}
          />

          <PaymentPanelSegment
            invoice={viewModel.details}
            canModify={viewModel.canModifyPayments}
          />

          <RecipientsPanel
            initialViewers={viewModel.viewers}
            invoice={viewModel.details}
          />

          <ReadonlyProductsPanelSegment productsPanel={viewModel.productsPanel} />

          {isPanelVisible(viewModel.linkedShowsPanel.config) && <ReadonlyLinkedShowsPanelSegment
            documentType={"invoice"}
            linkedShowsPanel={viewModel.linkedShowsPanel}
          />}

          <NotesPanel
            mainArea={"invoice"}
            useSectionPanel
            config={viewModel.linkedNotePanelConfig}
          />

        </SectionPanel.Section>
      </TwoColumnLayout.LeftColumn >
      <TwoColumnLayout.RightColumn>
        <InvoiceV2OptionsPanel
          optionsPanel={viewModel.optionsPanel}
          listUrl={viewModel.listUrl}
          invoice={viewModel.details}
          copyUrl={viewModel.copyUrl}
        />

        <InvoiceReminderApp
          document={viewModel.details}
          initialReminders={viewModel.reminders}
        />

        <InvoiceActivityPanel
          documentId={viewModel.details.documentId}
          config={viewModel.activityPanelConfig}
        />
      </TwoColumnLayout.RightColumn>
    </TwoColumnLayout >
  );
};

export default OutstandingPanel;